import { useEffect } from 'react';
import type { FC } from 'react';

import type { MultiBodiedExtensionActions } from '@atlaskit/editor-common/extensions/extension-handler';

import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';

import { ConnectMacroModule } from './MacroModule.tsx';

export const MultiBodiedExtensionHandler: FC<{
	macroId: string;
	macroParams: string;
	editorActions?: MultiBodiedExtensionActions;
	readonly?: boolean;
}> = ({ macroId, macroParams, editorActions, readonly = false }) => {
	useEffect(() => {
		if (!editorActions) {
			getMonitoringClient().submitError(
				new Error(
					`No editor actions has been provided to MultiBodiedExtensionHandler for macro ${macroId}.`,
				),
				{
					attribution: Attribution.ECOSYSTEM,
				},
			);
			return;
		}

		ConnectMacroModule.register(macroId, macroParams, editorActions, readonly);

		return () => {
			ConnectMacroModule.deregister(macroId);
		};
	}, [macroId, macroParams, editorActions, readonly]);

	return null;
};
